import Loadable from '../../components/loadable';

const EditStyle = Loadable({
  loader: () => import('../../pages/gradings/edit_style'),
  type: 'block',
});

angular.module('gym').value('EditStyle', EditStyle);
